import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Disclaimer from '../Disclaimer';
import MaterialSelector from '../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next';
import { view013ImageOptions } from './views/view013'


class Cockpit2 extends Component {
    constructor(props) {
        super(props);
		this.handleUpholsteryCockpitChange = this.handleUpholsteryCockpitChange.bind(this);
	}

	handleUpholsteryCockpitChange(newValue) {
		let configuration = this.props.configuration;
		configuration.UpholsteryCockpit = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}


    render() {
        let imageOptions = view013ImageOptions;

        let image = (
                <ConfiguratorImage boat="Xpower" configuration={this.props.configuration} options={imageOptions} />
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{ position: 'relative' }}>

					<h1><Trans defaults='Upholstery cockpit / deck' /></h1>
					<h2><Trans defaults='Leather and fabric options' /></h2>
					<p><Trans defaults='Durable long lasting upholstery fit for outdoor use.' /></p>
					<MaterialSelector options={this.props.UpholsteryCockpitOptions} label={this.props.configuration.UpholsteryCockpit.label} value={this.props.configuration.UpholsteryCockpit} onChange={this.handleUpholsteryCockpitChange} />
					

                    <Disclaimer />


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Cockpit2);


// WEBPACK FOOTER //
// ./src/Xpower/Cockpit2.js